import React from 'react';

import { UiKit } from 'components';
import * as RequestReasonsList from './RequestReasonsList';
import { FeatureContainer } from '../../components';
import { useFTUWizard } from '../../context';

export default function RequestReasons() {
  const { onGotoNext } = useFTUWizard();

  return (
    <FeatureContainer
      title="What reasons will you accept for customer returns?"
      subtitle="Select the reasons customers can select for returns or exchanges. We've created a few common ones to get started."
    >
      <UiKit.Flex direction="column" gap="16">
        <RequestReasonsList.Provider>
          <RequestReasonsList.List />
        </RequestReasonsList.Provider>
      </UiKit.Flex>
      <UiKit.Sheet.ActionsPortal>
        <UiKit.Button size="lg" onClick={() => onGotoNext()}>
          Continue
        </UiKit.Button>
      </UiKit.Sheet.ActionsPortal>
    </FeatureContainer>
  );
}
